exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container {\n  overflow-x: auto; }\n\ntable {\n  font-size: 13px; }\n\ntbody > tr > td {\n  vertical-align: middle; }\n\nthead {\n  background-color: #f9f9f9; }\n\n.noborder {\n  border: none !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/search/worksheet-result/worksheet-result.component.scss
// module id = ../../../../../src/app/search/worksheet-result/worksheet-result.component.scss
// module chunks = main